import { useMemo } from 'react';
import { defaultFetcher } from 'services/http';
import useSWR from 'swr';
import { generateUrl } from 'utils/url';

function useFetchedData(params, transformer = (d) => d, options = {}) {
  function getURL() {
    if (!params) {
      return null;
    }
    if (typeof params === 'string') {
      return params;
    }
    return generateUrl(params);
  }
  const { data, ...res } = useSWR(
    getURL(),
    defaultFetcher,
    {
      // Keep the data in cache even if window loses focus
      revalidateOnFocus: false,
      ...options
    }
  );
  const transformedData = useMemo(() => transformer(data), [data]);
  return {
    ...res,
    data: transformedData,
    loading: Boolean(params && !res.error && !data),
  };
}

export default useFetchedData;
